import Component from './twitter_applicant.vue'
export default Component
